import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DataTableModule } from "@bfx/primeng/datatable";
import { FieldsetModule } from "@bfx/primeng/fieldset";
import { TabViewModule } from "@bfx/primeng/tabview";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { BfxDealDetailsComponent } from "./bfx-deal-details.component";
import { BfxBlotterOrdersModule } from "../bfx-blotter-orders/bfx-blotter-orders.module";
import { TranslateModule } from "@ngx-translate/core";

import { BfxTradeBlotterModule } from "../bfx-blotter-trade/bfx-trade-blotter.module";

import { FormsModule } from "@angular/forms";
import { FlexLayoutModule } from "@angular/flex-layout";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxElementsLibraryModule } from "../bfx-element-library/bfx-elements-library.module";
import { OverlayPanel, OverlayPanelModule } from "@bfx/primeng/overlaypanel";
import { BfxPipeModule } from "app/bfx-shared/bfx-pipes.module";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    CommonModule,
    BfxSharedModule,
    DataTableModule,
    PerfectScrollbarModule, //PERFECT_SCROLLBAR_CONFIG
    FieldsetModule,
    FlexLayoutModule,
    FormsModule,
    OverlayPanelModule,
    TabViewModule,
    TranslateModule,
    BfxTradeBlotterModule,
    BfxBlotterOrdersModule,
    BfxElementsLibraryModule,
    BfxPipeModule,
  ],
  declarations: [BfxDealDetailsComponent],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  exports: [BfxDealDetailsComponent],
  bootstrap: [BfxDealDetailsComponent],
})
export class BfxDealDetailsModule {}
